module.exports = __webpack_public_path__ + "media/application/images/projects/images/scotland_hills-2a6b29388be536b9d190e21a23c65288.jpg";